import { getAlertMessageFunction, getDeleteDialogConfig } from '../../common/Util';
import { getNopaperDetail } from './evidenceDocumentsSlice';

// 데이터를 사람과 문서 종류별로 그룹화하는 함수
export const groupDataByPerson = dataList => {
  const groupedData = {};

  dataList.forEach(data => {
    const personKey = `${data.htmInsaPerNm}-${data.relation}`;

    if (!groupedData[personKey]) {
      groupedData[personKey] = {
        htmInsaPerNm: data.htmInsaPerNm,
        relation: data.relation,
        documents: {},
      };
    }

    if (!groupedData[personKey].documents[data.htmItemType]) {
      groupedData[personKey].documents[data.htmItemType] = {
        htmItemType: data.htmItemType,
        htmItemTypeName: data.htmItemTypeName,
        files: data.files,
      };
    }
  });

  return Object.values(groupedData);
};

export const deleteEvidenceDocuments = (dispatch, tCommon, data) => {
  const alertMessage = getAlertMessageFunction();

  const resultAction = dispatch(getDeleteDialogConfig(tCommon, 'evidenceDocuments', data));
  // console.log('resultAction', resultAction);
  // if (resultAction.resultCode === 'OK') {
  //   alertMessage(tCommon('alertMessage.deleteSuccess'), 'success');
  //   // onClose();
  // } else {
  //   alertMessage(tCommon('alertMessage.deleteFail'), 'error');
  // }
  return;
};

//증빙서류 상세 불러오는 함수
// export const fetchDetails = async (dispatch, originList, setDataList) => {
//   if (originList.length === 0) return;

//   try {
//     const detailedList = await Promise.all(
//       originList.map(async item => {
//         const response = await dispatch(
//           getNopaperDetail({
//             htmInsaPerNm: item.htmInsaPerNm,
//             htmItemType: item.htmItemType,
//           }),
//         ).unwrap();

//         const { list } = response;

//         return { ...item, files: list };
//       }),
//     );
//     // 데이터 목록 업데이트 예시
//     setDataList(detailedList);
//   } catch (error) {
//     console.error('증빙서류 상세 정보 로딩 실패:', error);
//   }
// };

// 증빙서류 상세 불러오는 함수 수정됨
export const fetchDetails = (originList, detailList, setDataList) => {
  if (originList.length === 0) return;

  const detailedList = originList.map(item => {
    const matchingDetails = detailList.filter(
      detail =>
        detail?.htmInsaPerNm?.trim() === item?.htmInsaPerNm?.trim() &&
        detail?.htmItemType?.trim() === item?.htmItemType?.trim(),
    );

    return {
      ...item,
      files: matchingDetails,
    };
  });

  setDataList(detailedList);
};
